import React from 'react';
import { AppShell, Box, useMantineTheme } from '@mantine/core';
import NavBar from '../NavBar/NavBar';
import { useSalon } from '../../context/SalonContext';
import { useMediaQuery } from '@mantine/hooks';

function AppLayout({ children }) {
  const { onboardingStage } = useSalon();
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <AppShell
      navbar={!isMobile ? { width: 60, breakpoint: 'sm' } : undefined}
      padding={0}
      styles={{
        main: {
          paddingTop: isMobile ? '53px' : 0,
          backgroundColor: theme.colors.gray[0]
        }
      }}
    >
      {!isMobile && (
        <AppShell.Navbar>
          <NavBar onboardingStage={onboardingStage} />
        </AppShell.Navbar>
      )}

      {isMobile && <NavBar onboardingStage={onboardingStage} />}

      <AppShell.Main>
        <Box>{children}</Box>
      </AppShell.Main>
    </AppShell>
  );
}

export default AppLayout;